import { __styles, mergeClasses, shorthands } from '@griffel/react';
import { DIALOG_GAP, MEDIA_QUERY_BREAKPOINT_SELECTOR, SURFACE_PADDING } from '../../contexts';
export const dialogBodyClassNames = {
  root: 'fui-DialogBody'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    mc9l5x: "f13qh94s",
    fshzfu: "f120kxnn",
    Bxyxcbc: "flnwrvu",
    B7ck84d: "f1ewtqcl",
    B68tc82: "f1ln0qer",
    Bmxbyg5: "fa2wlxz",
    i8kkvl: "f4px1ci",
    Belr9w4: "fn67r4l",
    wkccdc: "f1x46k84",
    Budl1dq: "fjj47a5",
    B5xtmjs: "ff54dml",
    Bqu9lor: "f1t97isy"
  }
}, {
  d: [".f13qh94s{display:-ms-grid;display:grid;}", ".f120kxnn::backdrop{background-color:rgba(0, 0, 0, 0.4);}", ".flnwrvu{max-height:calc(100vh - 2 * 24px);}", ".f1ewtqcl{box-sizing:border-box;}", ".f1ln0qer{overflow-x:unset;}", ".fa2wlxz{overflow-y:unset;}", ".f4px1ci{-webkit-column-gap:8px;column-gap:8px;}", ".fn67r4l{row-gap:8px;}", ".f1x46k84{-ms-grid-rows:auto 1fr;grid-template-rows:auto 1fr;}", ".fjj47a5{-ms-grid-columns:1fr 1fr auto;grid-template-columns:1fr 1fr auto;}"],
  m: [["@media screen and (max-width: 480px){.ff54dml{max-width:100vw;}}", {
    m: "screen and (max-width: 480px)"
  }], ["@media screen and (max-width: 480px){.f1t97isy{-ms-grid-rows:auto 1fr auto;grid-template-rows:auto 1fr auto;}}", {
    m: "screen and (max-width: 480px)"
  }]]
});
/**
 * Apply styling to the DialogBody slots based on the state
 */
export const useDialogBodyStyles_unstable = state => {
  const styles = useStyles();
  state.root.className = mergeClasses(dialogBodyClassNames.root, styles.root, state.root.className);
  return state;
};
//# sourceMappingURL=useDialogBodyStyles.styles.js.map